import {Injectable} from '@angular/core';
import {EventEmitter} from "events";
import {UserEvent} from '../models/global.model';

@Injectable({
  providedIn: 'root'
})
export class EventService {

  private emitter: EventEmitter;

  constructor() {
    this.setupEmitter();
  }

  setupEmitter() {
    this.emitter = new EventEmitter();
    this.emitter.setMaxListeners(100);
  }

  // Keep updated about changes
  on(action: UserEvent, listener: (args: unknown) => void) {
    this.emitter.on(action, listener);
    return (() => this.off(action, listener));
  }

  // Remove listener
  off(action: UserEvent, listener: (args: unknown) => void) {
    this.emitter.off(action, listener);
  }

  // Emit event
  emit(action: UserEvent, args?: unknown) {
    this.emitter.emit(action, args);
  }
}
